import { GAME_RESULT } from "../constants";
/**
 * Check the chess instance for game result
 * @param chess - The chess.js instance
 * @returns The game result or null if the game is not over
 */
export function checkGameResult(chess) {
    if (!chess.game_over()) {
        return null;
    }
    if (chess.in_checkmate()) {
        return GAME_RESULT.CHECKMATE;
    }
    if (chess.in_stalemate()) {
        return GAME_RESULT.STALEMATE;
    }
    if (chess.in_threefold_repetition()) {
        return GAME_RESULT.THREEFOLD_REPETITION;
    }
    if (chess.insufficient_material()) {
        return GAME_RESULT.INSUFFICIENT_MATERIAL;
    }
    if (chess.in_draw()) {
        return GAME_RESULT.DRAW;
    }
    return GAME_RESULT.GAME_OVER;
}
/**
 * Generate a human-readable result string based on the game result and the color of the last move
 * @param result - The game result
 * @param lastMoveColor - The color of the player who made the last move
 * @returns A human-readable result string
 */
export function generateResultString(result, lastMoveColor) {
    if (!result) {
        return "";
    }
    switch (result) {
        case GAME_RESULT.CHECKMATE:
            return `${lastMoveColor.toUpperCase()} wins by checkmate`;
        case GAME_RESULT.STALEMATE:
            return "Draw by stalemate";
        case GAME_RESULT.THREEFOLD_REPETITION:
            return "Draw by threefold repetition";
        case GAME_RESULT.INSUFFICIENT_MATERIAL:
            return "Draw by insufficient material";
        case GAME_RESULT.DRAW:
            return "Draw";
        default:
            return "Game over";
    }
}
